var map = {
	"./Group 22302.png": 1286,
	"./avatar-christmas.webp": 1287,
	"./bottom-bg-christmas.webp": 1288,
	"./btn-active.png": 1289,
	"./content-deco-1.webp": 1290,
	"./content-deco-2.webp": 1291,
	"./content-deco-3.webp": 1292,
	"./content-deco-4.webp": 1293,
	"./deco-3.webp": 1294,
	"./deposit-icon.webp": 1295,
	"./home-icon-active.webp": 1296,
	"./home-icon.webp": 1297,
	"./live-icon-active.webp": 1298,
	"./live-icon.webp": 1299,
	"./master-bg.jpg": 1300,
	"./me-icon-active.webp": 1301,
	"./me-icon.webp": 1302,
	"./platform.png": 1303,
	"./platform.webp": 1304,
	"./promos-icon-active.webp": 1305,
	"./promos-icon.webp": 1306,
	"./promos.webp": 1307,
	"./service-christmas.webp": 1308,
	"./snowman.webp": 1309,
	"./sponsor-icon-active.webp": 1310,
	"./sponsor-icon.webp": 1311,
	"./title-deco-left.webp": 1312,
	"./title-deco-right.webp": 1313,
	"./tree.webp": 1314,
	"./vip-icon.webp": 1315,
	"./vip.webp": 1316,
	"./withdraw-icon.webp": 1317,
	"./wwr-img.webp": 1318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;